export default "__VITE_ASSET__BUCxDM5X__"